//CURENT DATE TIME FUNCTION
function ShowDate()
{
	var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

	var dNow = new Date();
	var localdate= (days[dNow.getDay()] + ', ' + months[dNow.getMonth()] + ' ' + dNow.getDate() + ', ' + dNow.getFullYear());

	$('#currentDate').html(localdate)
}
// Active and Remove Class
$('.sidebar-expand-collapse a').click(function(){
  $('.sidebar-expand-collapse a').removeClass("active");
  $(this).addClass("active");
});
// Dropdown in Table grid
$(function() {
  //add BT DD show event
  $(".action-items").on("show.bs.dropdown", function() {
    var $btnDropDown = $(this).find(".dropdown-toggle");
    var $listHolder = $(this).find(".dropdown-menu");
    //reset position property for DD container
    $(this).css("position", "static");
    $listHolder.css({
      "top": ($btnDropDown.offset().top + $btnDropDown.outerHeight(true))+"px",
      "left": $btnDropDown.offset().left+"px"
    });
    $listHolder.data("open", true);
  });
  //add BT DD hide event
  $(".action-items").on("hidden.bs.dropdown", function() {
    var $listHolder = $(this).find(".dropdown-menu");
    $listHolder.data("open", false);
  });
  //add on scroll for table holder
  $(".dropdownparent").scroll(function(){
    var $ddHolder = $(this).find(".action-items")
    var $btnDropDown = $(this).find(".dropdown-toggle");
    var $listHolder = $(this).find(".dropdown-menu");
    if ($listHolder.data("open")){
      $listHolder.css({
        "top": ($btnDropDown.offset().top + $btnDropDown.outerHeight(true))+"px",
        "left": $btnDropDown.offset().left+"px"
      });
      $ddHolder.toggleClass("open", ($btnDropDown.offset().left > $(this).offset().left))
    }
  })
});



